export const getErrorMessageFromData = (errorData) => {
  if (!errorData) {
    return '';
  }
  if (errorData.non_field_errors) {
    return errorData.non_field_errors[0];
  }
  if (errorData.detail) {
    return errorData.detail;
  }
};
